import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "page-wrapper" }
const _hoisted_2 = { class: "avatar_container" }
const _hoisted_3 = { class: "profileImg" }
const _hoisted_4 = ["src"]

import { ref } from 'vue';
import CustomHeader from '../components/common/customHeader.vue';
import MainButton from '../components/common/mainButton.vue';
import { AvatarData } from '@/view/profile/supportScript';



export default /*@__PURE__*/_defineComponent({
  __name: 'avatarView',
  props: {
    dataSet: {}
  },
  emits: ['afterRead'],
  setup(__props: any, { emit: __emit }) {

const props = __props

const isPopupCloseBackIcon = ref(true)


const emits = __emit

const afterRead = (file: any) => {
   emits('afterRead', file)
};


return (_ctx: any,_cache: any) => {
  const _component_van_uploader = _resolveComponent("van-uploader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (isPopupCloseBackIcon.value)
      ? (_openBlock(), _createElementBlock("i", {
          key: 0,
          class: "back-icon",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.back()))
        }))
      : _createCommentVNode("", true),
    _createVNode(CustomHeader, {
      text: _ctx.$t('profile.configuration')
    }, null, 8, ["text"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          src: _ctx.dataSet?.avatarImg,
          alt: ""
        }, null, 8, _hoisted_4)
      ]),
      _createVNode(_component_van_uploader, {
        class: "uploader",
        "after-read": afterRead
      }, {
        default: _withCtx(() => [
          _createVNode(MainButton, {
            title: _ctx.$t('profile.choosePhoto'),
            activeStatus: true
          }, null, 8, ["title"])
        ]),
        _: 1
      })
    ])
  ]))
}
}

})